import React, { useEffect, useState } from "react";
import "./HappyMoments.css";

const services = [
  {
    number: "01",
    title: "Wedding Films",
    description:
      "Cinematic wedding films crafted around your emotions, moments and story.",
  },
  {
    number: "02",
    title: "Highlight Films",
    description:
      "Short, powerful edits that capture the most unforgettable moments of your celebration.",
  },
  {
    number: "03",
    title: "Wedding Reels",
    description:
      "Modern social-first wedding reels designed to make your memories impossible to scroll past.",
  },
  {
    number: "04",
    title: "Teaser Edits",
    description:
      "A cinematic preview of your story, built around rhythm, emotion and anticipation.",
  },
];

const process = [
  {
    number: "01",
    title: "You Send",
    text: "Share your raw wedding footage with us.",
  },
  {
    number: "02",
    title: "We Understand",
    text: "We study your moments, music and the story you want to tell.",
  },
  {
    number: "03",
    title: "We Edit",
    text: "Our editors shape your footage into a cinematic experience.",
  },
  {
    number: "04",
    title: "You Relive",
    text: "You receive a film you'll want to watch again and again.",
  },
];

// const portfolio = [
//   {
//     category: "WEDDING FILM",
//     title: "The Beginning",
//     image: "/happymoments/wedding-2.jpg",
//   },
//   {
//     category: "HIGHLIGHT",
//     title: "Forever Starts Here",
//     image: "/happymoments/azimbanner.png",
//   },
//   {
//     category: "WEDDING REEL",
//     title: "Two Souls",
//     image: "/happymoments/wedding-1.jpg",
//   },
// ];

const portfolio = [
  {
    category: "WEDDING FILM",
    title: "The Beginning",
    year: "2025",
    image: "/happymoments/wedding-2.jpg",
    youtubeId: "ztQoCJlC4UI",
  },
  {
    category: "WEDDING HIGHLIGHT",
    title: "Forever Starts Here",
    year: "2025",
    image: "/happymoments/azimbanner.png",
    youtubeId: "b5QGCA8LxI4",
  },
  {
    category: "WEDDING REEL",
    title: "Two Souls",
    year: "2025",
    image: "/happymoments/wedding-1.jpg",
    youtubeId: "3wDnIk5tuwY",
  },
];


function ArrowUpRight() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 19L19 5M8 5H19V16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowDown() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4V20M6 14L12 20L18 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.5V18.5L18.5 12L8 5.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

function MenuIcon({ open }) {
  return (
    <div className={`hm-menu-icon ${open ? "open" : ""}`}>
      <span />
      <span />
    </div>
  );
}

export default function HappyMoments() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="happy-moments-page">
      {/* Grain overlay */}
      <div className="hm-grain" />

      {/* ================= NAVBAR ================= */}
      <header className={`hm-navbar ${scrolled ? "scrolled" : ""}`}>
        <a href="#home" className="hm-logo" onClick={closeMenu}>
          <span className="hm-logo-mark">H</span>
          <span className="hm-logo-text">
            HAPPY
            <strong>MOMENTS</strong>
          </span>
        </a>

        <nav className={`hm-nav ${menuOpen ? "mobile-open" : ""}`}>
          <a href="#work" onClick={closeMenu}>
            Work
          </a>

          <a href="#services" onClick={closeMenu}>
            Services
          </a>

          <a href="#process" onClick={closeMenu}>
            Process
          </a>

          <a href="#about" onClick={closeMenu}>
            About
          </a>

          <a
            href="#contact"
            className="hm-nav-contact"
            onClick={closeMenu}
          >
            Let's Talk
            <ArrowUpRight />
          </a>
        </nav>

        <button
          className="hm-menu-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <MenuIcon open={menuOpen} />
        </button>
      </header>

      {/* ================= HERO ================= */}
      <main id="home">
        <section className="hm-hero">
          <div className="hm-hero-content">
            <div className="hm-eyebrow">
              <span className="hm-eyebrow-line" />
              WEDDING FILM EDITING STUDIO
            </div>

            <h1>
              WE EDIT YOUR
              <span>MEMORIES</span>
              INTO CINEMA.
            </h1>

            <p className="hm-hero-description">
              Your wedding already has the moments.
              We turn them into a story worth watching
              for years to come.
            </p>

            <div className="hm-hero-actions">
              <a href="#work" className="hm-button hm-button-light">
                View Our Work
                <ArrowUpRight />
              </a>

              <a href="#contact" className="hm-button hm-button-outline">
                Start A Project
              </a>
            </div>
          </div>

          <div className="hm-hero-visual">
            <div className="hm-hero-image">
              <div className="hm-image-placeholder hero-placeholder">
                <span>YOUR</span>
                <strong>STORY</strong>
              </div>
            </div>

            <div className="hm-hero-side-text">
              <span>EST.</span>
              <strong>2024</strong>
            </div>

            <div className="hm-hero-scroll">
              <span>SCROLL TO EXPLORE</span>
              <ArrowDown />
            </div>
          </div>
        </section>

        {/* ================= INTRO ================= */}
        <section className="hm-intro" id="about">
          <div className="hm-section-label">
            <span>01</span>
            WHAT IS HAPPY MOMENTS?
          </div>

          <div className="hm-intro-content">
            <h2>
              THE MOMENT
              <br />
              IS YOURS.
              <br />
              <em>THE STORY IS OURS.</em>
            </h2>

            <div className="hm-intro-copy">
              <p className="large-copy">
                Happy Moments is a wedding video editing studio
                built for couples, photographers and wedding
                filmmakers who believe their footage deserves more.
              </p>

              <p>
                From the quiet glance before the ceremony to the
                wild dance floor at midnight, we transform raw
                footage into films that feel personal, modern and
                timeless.
              </p>

              <a href="#services" className="hm-text-link">
                Discover what we do
                <ArrowUpRight />
              </a>
            </div>
          </div>
        </section>

        {/* ================= MARQUEE ================= */}
        <section className="hm-marquee">
          <div className="hm-marquee-track">
            <span>LOVE</span>
            <i>✦</i>
            <span>STORIES</span>
            <i>✦</i>
            <span>EMOTION</span>
            <i>✦</i>
            <span>MEMORIES</span>
            <i>✦</i>
            <span>LOVE</span>
            <i>✦</i>
            <span>STORIES</span>
            <i>✦</i>
          </div>
        </section>

        {/* ================= WORK ================= */}
        {/* <section className="hm-work" id="work">
          <div className="hm-section-header">
            <div className="hm-section-label">
              <span>02</span>
              SELECTED WORK
            </div>

            <p>
              Every wedding has a different rhythm.
              <br />
              So should every film.
            </p>
          </div>

          <div className="hm-portfolio-grid">
            {portfolio.map((item, index) => (
              <article
                className={`hm-portfolio-card card-${index + 1}`}
                key={item.title}
              >
                <div className="hm-portfolio-image">
                  <img
                    src={item.image}
                    alt={item.title}
                    // onError={(e) => {
                    //   e.currentTarget.style.display = "none";
                    // }}
                  />

                  <div className="hm-image-placeholder">
                    <span>HAPPY</span>
                    <strong>MOMENTS</strong>
                  </div>

                  <div className="hm-play-button">
                    <PlayIcon />
                  </div>
                </div>

                <div className="hm-portfolio-info">
                  <span>{item.category}</span>

                  <h3>{item.title}</h3>

                  <ArrowUpRight />
                </div>
              </article>
            ))}
          </div>

          <div className="hm-work-footer">
            <span>MORE STORIES COMING SOON</span>
            <div className="hm-line" />
          </div>
        </section> */}

        <section className="hm-work" id="work">
  <div className="hm-section-header">
    <div className="hm-section-label">
      <span>02</span>
      SELECTED WORK
    </div>

    <p>
      Every wedding has a different rhythm.
      <br />
      So should every film.
    </p>
  </div>

  <div className="hm-portfolio-grid">
    {portfolio.map((item, index) => (
      <article
        className={`hm-portfolio-card card-${index + 1}`}
        key={item.title}
        onClick={() => setActiveVideo(item)}
      >
        <div className="hm-portfolio-image">

          <img
            src={item.image}
            alt={item.title}
          />

          <div className="hm-image-overlay" />

          <div className="hm-video-play">
            <PlayIcon />
          </div>

          <div className="hm-video-label">
            WATCH FILM
          </div>
        </div>

        <div className="hm-portfolio-info">
          <span>
            {item.category} — {item.year}
          </span>

          <h3>{item.title}</h3>

          <ArrowUpRight />
        </div>
      </article>
    ))}
  </div>

  <div className="hm-work-footer">
    <span>MORE STORIES COMING SOON</span>
    <div className="hm-line" />
  </div>
</section>


{activeVideo && (
  <div
    className="hm-video-modal"
    onClick={() => setActiveVideo(null)}
  >
    <button
      className="hm-video-close"
      onClick={() => setActiveVideo(null)}
      aria-label="Close video"
    >
      ×
    </button>

    <div
      className="hm-video-container"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="hm-youtube-wrapper">
        <iframe
          src={`https://www.youtube.com/embed/${activeVideo.youtubeId}?autoplay=1&rel=0`}
          title={activeVideo.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>

      <div className="hm-video-title">
        <span>
          {activeVideo.category} — {activeVideo.year}
        </span>

        <strong>{activeVideo.title}</strong>
      </div>
    </div>
  </div>
)}


        {/* ================= SERVICES ================= */}
        <section className="hm-services" id="services">
          <div className="hm-section-label">
            <span>03</span>
            WHAT WE DO
          </div>

          <div className="hm-services-heading">
            <h2>
              FROM RAW
              <br />
              FOOTAGE TO
              <br />
              <em>TIMELESS.</em>
            </h2>

            <p>
              We combine modern editing techniques with
              intentional storytelling to create wedding films
              that feel as beautiful as the day itself.
            </p>
          </div>

          <div className="hm-services-list">
            {services.map((service) => (
              <div className="hm-service" key={service.number}>
                <span className="hm-service-number">
                  {service.number}
                </span>

                <h3>{service.title}</h3>

                <p>{service.description}</p>

                <ArrowUpRight />
              </div>
            ))}
          </div>
        </section>

        {/* ================= CINEMATIC STATEMENT ================= */}
        <section className="hm-statement">
          <div className="hm-statement-background">
            <div className="hm-statement-image">
              <span>THE BEST</span>
              <strong>MOMENTS</strong>
              <small>ARE FELT, NOT STAGED.</small>
            </div>
          </div>

          <div className="hm-statement-content">
            <span className="hm-statement-small">
              BECAUSE YOUR WEDDING
              <br />
              IS MORE THAN A DAY.
            </span>

            <h2>
              IT'S A
              <br />
              <em>MEMORY.</em>
            </h2>
          </div>
        </section>

        {/* ================= PROCESS ================= */}
        <section className="hm-process" id="process">
          <div className="hm-section-label">
            <span>04</span>
            OUR PROCESS
          </div>

          <div className="hm-process-heading">
            <h2>
              SIMPLE.
              <br />
              PERSONAL.
              <br />
              <em>CINEMATIC.</em>
            </h2>

            <p>
              From your first upload to the final frame,
              we keep the process simple and focused on
              your story.
            </p>
          </div>

          <div className="hm-process-list">
            {process.map((step) => (
              <div className="hm-process-item" key={step.number}>
                <div className="hm-process-number">
                  {step.number}
                </div>

                <div className="hm-process-main">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>

                <div className="hm-process-arrow">
                  <ArrowDown />
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ================= WHY US ================= */}
        <section className="hm-why">
          <div className="hm-section-label">
            <span>05</span>
            WHY HAPPY MOMENTS?
          </div>

          <div className="hm-why-grid">
            <div>
              <h2>
                WE DON'T
                <br />
                JUST <em>EDIT.</em>
              </h2>
            </div>

            <div className="hm-why-copy">
              <p className="large-copy">
                We look for the moments between the moments.
              </p>

              <p>
                The smile that lasted half a second.
                The nervous hands. The parents watching.
                The laugh nobody planned.
              </p>

              <p>
                Those are the details that make a wedding
                yours — and those are the details we build
                our films around.
              </p>

              <div className="hm-feature-list">
                <span>01 — EMOTIONAL STORYTELLING</span>
                <span>02 — MODERN EDITING</span>
                <span>03 — CINEMATIC COLOR</span>
                <span>04 — MUSIC SYNCHRONIZATION</span>
                <span>05 — DETAIL-FOCUSED WORK</span>
              </div>
            </div>
          </div>
        </section>

        {/* ================= CTA ================= */}
        <section className="hm-cta" id="contact">
          <div className="hm-cta-top">
            <span>06 / LET'S CREATE SOMETHING</span>
            <span>HAPPY MOMENTS™</span>
          </div>

          <div className="hm-cta-content">
            <p>
              GOT FOOTAGE?
              <br />
              LET'S MAKE
            </p>

            <h2>
              SOMETHING
              <br />
              <em>UNFORGETTABLE.</em>
            </h2>

            <a
              href="mailto:contact@azybyte.in"
              className="hm-cta-button"
            >
              <span>START A PROJECT</span>
              <ArrowUpRight />
            </a>
          </div>
        </section>
      </main>

      {/* ================= FOOTER ================= */}
      <footer className="hm-footer">
        <div className="hm-footer-top">
          <div className="hm-footer-brand">
            <div className="hm-footer-logo">
              <span className="hm-logo-mark">H</span>

              <span className="hm-logo-text">
                HAPPY
                <strong>MOMENTS</strong>
              </span>
            </div>

            <p>
              Turning wedding footage
              <br />
              into stories worth reliving.
            </p>
          </div>

          <div className="hm-footer-links">
            <div>
              <span>EXPLORE</span>
              <a href="#work">Work</a>
              <a href="#services">Services</a>
              <a href="#process">Process</a>
            </div>

            <div>
              <span>CONTACT</span>
              <a href="mailto:contact@azybyte.in">
                Email Us
              </a>
              <a href="#contact">Start a Project</a>
            </div>
          </div>
        </div>

        <div className="hm-footer-bottom">
          <span>© {new Date().getFullYear()} HAPPY MOMENTS</span>

          <span>AN AZYBYTE AGENCY</span>

          <a href="#home">BACK TO TOP ↑</a>
        </div>
      </footer>
    </div>
  );
}
